module.exports = __webpack_public_path__ + "static/media/monitor_company.f4f4d0cb.svg";